if (!customElements.get('ugc-section-component')) {
  class UGCSectionComponent extends HTMLElement {
    constructor() {
      super();
      this.swiperInstance = null;
    }

    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.section = this.closest('.ugc-section');

      this.init();
    }

    init() {
      if (typeof Swiper === 'undefined') {
        this.loadSwiper().then(() => {
          this.initSlider();
          this.initVideos();
        });
      } else {
        this.initSlider();
        this.initVideos();
      }
    }

    loadSwiper() {
      return new Promise((resolve, reject) => {
        if (!document.querySelector('[data-swiper-css]')) {
          const swiperCSS = document.createElement('link');
          swiperCSS.rel = 'stylesheet';
          swiperCSS.href = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';
          swiperCSS.dataset.swiperCss = '';
          document.head.appendChild(swiperCSS);
        }

        if (!document.querySelector('[data-swiper-js]')) {
          const swiperJS = document.createElement('script');
          swiperJS.src = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
          swiperJS.dataset.swiperJs = '';
          swiperJS.onload = () => resolve();
          swiperJS.onerror = () => reject(new Error('Failed to load Swiper'));
          document.head.appendChild(swiperJS);
        } else {
          const checkSwiper = setInterval(() => {
            if (typeof Swiper !== 'undefined') {
              clearInterval(checkSwiper);
              resolve();
            }
          }, 50);
        }
      });
    }

    initSlider() {
      const swiperEl = this.querySelector('.ugc-section__swiper');
      if (!swiperEl) return;

      const pagination = this.section.querySelectorAll('.ugc-section__pagination');
      const prevBtns = this.section.querySelectorAll('.ugc-section__nav-prev');
      const nextBtns = this.section.querySelectorAll('.ugc-section__nav-next');

      this.swiperInstance = new Swiper(swiperEl, {
        slidesPerView: 'auto',
        spaceBetween: 6,
        navigation: {
          nextEl: nextBtns[0],
          prevEl: prevBtns[0],
        },
        pagination: {
          el: pagination[0],
          clickable: true,
        },
        breakpoints: {
          990: {
            spaceBetween: 18,
          },
        },
        loop: false,
      });

      setTimeout(() => {
        this.bindExtraNavigation(prevBtns, nextBtns, pagination);
      }, 0);
    }

    bindExtraNavigation(prevBtns, nextBtns, paginationEls) {
      if (!this.swiperInstance) return;

      prevBtns.forEach((btn, index) => {
        if (index > 0) {
          btn.addEventListener('click', () => this.swiperInstance.slidePrev());
        }
      });

      nextBtns.forEach((btn, index) => {
        if (index > 0) {
          btn.addEventListener('click', () => this.swiperInstance.slideNext());
        }
      });

      const slidesCount = this.swiperInstance.slides.length;
      paginationEls.forEach((el, paginationIndex) => {
        if (paginationIndex > 0 && slidesCount > 0) {
          el.innerHTML = '';
          for (let i = 0; i < slidesCount; i++) {
            const bullet = document.createElement('span');
            bullet.className = 'swiper-pagination-bullet' + (i === this.swiperInstance.activeIndex ? ' swiper-pagination-bullet-active' : '');
            bullet.addEventListener('click', () => {
              this.swiperInstance.slideTo(i);
            });
            el.appendChild(bullet);
          }
        }
      });

      this.swiperInstance.on('slideChange', () => {
        const activeIndex = this.swiperInstance.activeIndex;
        paginationEls.forEach(el => {
          const bullets = el.querySelectorAll('.swiper-pagination-bullet');
          bullets.forEach((bullet, index) => {
            bullet.classList.toggle('swiper-pagination-bullet-active', index === activeIndex);
          });
        });
      });
    }

    initVideos() {
      const deferredMedias = this.querySelectorAll('deferred-media');
      deferredMedias.forEach(media => {
        this.initDeferredMedia(media);
      });
    }

    initDeferredMedia(deferredMedia) {
      const playBtn = deferredMedia.querySelector('.ugc-section__play-btn');
      const muteBtn = deferredMedia.querySelector('.ugc-section__mute-btn');
      const clickArea = deferredMedia.querySelector('.ugc-section__video-click-area');
      const template = deferredMedia.querySelector('template');

      if (!template) return;

      deferredMedia.classList.add('is-muted');

      const handlePlayClick = (e) => {
        e.stopPropagation();
        this.togglePlayPause(deferredMedia, template);
      };

      if (playBtn) {
        playBtn.addEventListener('click', handlePlayClick);
      }

      if (clickArea) {
        clickArea.addEventListener('click', handlePlayClick);
      }

      if (muteBtn) {
        muteBtn.addEventListener('click', (e) => {
          e.stopPropagation();
          this.toggleMute(deferredMedia);
        });
      }
    }

    togglePlayPause(deferredMedia, template) {
      let video = deferredMedia.querySelector('.ugc-section__video-element');

      if (!video) {
        const content = template.content.cloneNode(true);
        deferredMedia.appendChild(content);
        video = deferredMedia.querySelector('.ugc-section__video-element');

        if (video) {
          video.muted = true;

          video.addEventListener('playing', () => {
            deferredMedia.classList.add('is-playing');
          });

          video.addEventListener('pause', () => {
            deferredMedia.classList.remove('is-playing');
          });

          video.addEventListener('ended', () => {
            deferredMedia.classList.remove('is-playing');
          });

          video.addEventListener('click', () => {
            this.togglePlayPause(deferredMedia, template);
          });

          video.play().then(() => {
            deferredMedia.classList.add('is-playing');
          }).catch(() => {});
        }
      } else {
        if (video.paused) {
          video.play().then(() => {
            deferredMedia.classList.add('is-playing');
          }).catch(() => {});
        } else {
          video.pause();
          deferredMedia.classList.remove('is-playing');
        }
      }
    }

    toggleMute(deferredMedia) {
      const video = deferredMedia.querySelector('.ugc-section__video-element');
      if (!video) return;

      video.muted = !video.muted;
      deferredMedia.classList.toggle('is-muted', video.muted);
    }

    disconnectedCallback() {
      if (this.swiperInstance) {
        this.swiperInstance.destroy(true, true);
      }
    }
  }

  customElements.define('ugc-section-component', UGCSectionComponent);
}

document.addEventListener('shopify:section:load', (event) => {
  const section = event.target.querySelector('ugc-section-component');
  if (section) {
    section.init();
  }
});
